import { Components } from '@mui/material/styles/components';

export const CssBaselineComponent: Components = {
  MuiCssBaseline: {
    styleOverrides: `
      body {
        letter-spacing: normal;
      }
    `,
  },
};
